import React, { useEffect, useState } from "react";
import "./ServiceHero.css";
import serviceCategories from "../serviceData";


const ServiceHero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    // Move to next slide
    const nextSlide = () => {
        setCurrentSlide((prev) =>
            prev === serviceCategories.flatMap(category => category.services).length - 1 ? 0 : prev + 1
        );
    };
    // Move to previous slide
    const prevSlide = () => {
        setCurrentSlide((prev) =>
            prev === 0 ? serviceCategories.flatMap(category => category.services).length - 1 : prev - 1
        );
    };
    // Auto play
    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    // Keyboard navigation
    useEffect(() => {
        const handleKey = (event) => {
            if(event.key === "ArrowRight"){
                nextSlide();
            }
            if(event.key === "ArrowLeft"){
                prevSlide();
            }
        };
        window.addEventListener(
            "keydown",
            handleKey
        );
        return () =>
            window.removeEventListener(
                "keydown",
                handleKey
            );
    }, []);
    return (
        <section className="serviceHero">
            {
                serviceCategories.flatMap(category => category.services).map((service, index) => (
                    <div
                        className={`serviceSlide ${
                            index === currentSlide 
                            ? "active"
                            : ""
                        }`}
                        key={index}
                        style={{
                            backgroundImage:
                            `url(${service.image})`
                        }}
                    >
                        <div className="overlay"></div>
                        <div className="serviceContent">
                            <h1>
                                {service.title}
                            </h1>
                            <p>
                                {service.tagline}
                            </p>
                        </div>
                    </div>
                ))
            }
            {/* Navigation Buttons */}
            <button
                className="heroBtn prev"
                onClick={prevSlide}
                aria-label="Previous slide"
            >
                ←
            </button>
            <button
                className="heroBtn next"
                onClick={nextSlide}
                aria-label="Next slide"
            >
                →
            </button>
            {/* Dots */}
            <div className="dots">
                {
                    serviceCategories.flatMap(category => category.services).map((_,index)=>(
                        <button
                            key={index}
                            className={
                                index === currentSlide
                                ? "dot activeDot"
                                : "dot"
                            }
                            onClick={() =>
                                setCurrentSlide(index)
                            }
                            aria-label={`Go to slide ${index+1}`}
                        >
                        </button>
                    ))
                }
            </div>
        </section>
    );
};
export default ServiceHero;